export const NAV = {
  brand: 'nav-brand',
  linkInicio: 'nav-link-inicio',
  linkNosotros: 'nav-link-nosotros',
  linkGenetica: 'nav-link-genetica',
  linkTecnologia: 'nav-link-tecnologia',
  linkProduccion: 'nav-link-produccion',
  linkLegado: 'nav-link-legado',
  linkContacto: 'nav-link-contacto',
  ctaContact: 'nav-cta-contact',
  mobileToggle: 'nav-mobile-toggle',
};

export const HERO = {
  section: 'hero-section',
  ctaHistoria: 'hero-cta-historia',
  ctaContacto: 'hero-cta-contacto',
};

export const CONTACT = {
  form: 'contact-form',
  name: 'contact-name',
  email: 'contact-email',
  phone: 'contact-phone',
  message: 'contact-message',
  submit: 'contact-submit',
  successAlert: 'contact-success',
  errorAlert: 'contact-error',
  whatsapp: 'contact-whatsapp-btn',
};

export const SECTIONS = {
  nosotros: 'section-nosotros',
  genetica: 'section-genetica',
  tecnologia: 'section-tecnologia',
  produccion: 'section-produccion',
  legado: 'section-legado',
  contacto: 'section-contacto',
};
